export const PROACTIVE_DRAFT_PROPERTY_SET_ID = '41f28f13-83f4-4114-a584-eedb5a6b0bff';
export const IS_COPILOT_PROACTIVE_DRAFT_PROPERTY_NAME = 'IsCopilotProactiveDraft';
export const PROACTIVE_DRAFT_GENERATION_PROPERTIES_NAME = 'ProactiveDraftGenerationProperties';
